import { Component, OnInit } from '@angular/core';

import { GridDataResult, GridComponent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

import {AllocationModalComponent} from '../allocation-modal/allocation-modal.component';
import {ErrorModalComponent} from '../error-modal/error-modal.component';
import {environment} from '../../environments/environment';
import { FlexFileError } from '../shared/errors/FlexFileError';

@Component({
  selector: 'app-validation',
  templateUrl: './validation.component.html',
  styleUrls: ['./validation.component.scss']
})
export class ValidationComponent implements OnInit {
  report: Report;
  gridData: Array<any> = [];
  gridView: GridDataResult;
  sort: SortDescriptor[] = [];
  errorModal: BsModalRef;
  errors: Array<any>;

  state: State = {
    skip: 0,
    take: 50
  };

  constructor(private modalService: BsModalService, private reportService: ReportDataService) {
    this.report = reportService.getReport();
  }

  ngOnInit() {
    /*
    for (let i = 0; i < this.report.Errors.length; i++) {
      this.gridData.push(this.report.Errors[i]);
    }
    */
    this.errors = this.report.Errors;
  }

  fixError( error: FlexFileError) {
    this.reportService.currentError = error;
    this.errorModal = this.modalService.show(AllocationModalComponent, {class: 'modal-lg', keyboard: false, ignoreBackdropClick: true});
  }

  showError( error: FlexFileError) {
    this.reportService.currentError = error;
    this.errorModal = this.modalService.show(ErrorModalComponent, {class: 'modal-lg', keyboard: false, ignoreBackdropClick: true});
  }
  public dataStateChange(state: DataStateChangeEvent): void {
  }

}



// WEBPACK FOOTER //
// ./src/app/validation/validation.component.ts